<template>
    <div class="d-flex align-items-center">
        <p 
            class="d-flex align-items-center status" 
            :class="data.status">
            {{data.status}}
        </p>
        <p 
            v-if="data.failureMessage" 
            class="info-sign" 
            v-b-tooltip.right 
            :title="data.failureMessage" 
            icon="hint-icon">
            i
        </p>
    </div>
</template>

<script>
export default {
    name: "InvoiceStatus",
    props: {
        data: Object
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/variables.scss';

    .status {
        text-transform: capitalize;
    }
    .status::before {
        content: '';
        width: 5px;
        height: 5px;
        border-radius: 50%;
        margin-top: 3px;
        margin-right: 4px
    }
    .paid::before {
        background-color: $c2
    }

    .failed::before {
        background-color: $c5
    }

    .info-sign {
        text-transform: none;
        color: #ffffff;
        font-size: 13px;
        background: #333333a1;
        display: block;
        width: 16px;
        height: 16px;
        line-height: 18px;
        text-align: center;
        margin-left: 10px;
        border-radius: 50%;
        cursor: pointer;
    }
</style>